<template>
  	<FlexPinList />
</template>

<script>

// @ is an alias to /src
import FlexPinList from "@/components/Flex/PinList.vue";

export default {
  name: "FlexPinLists",
  components: {
    FlexPinList,
  },
};
</script>
